import React, { ReactNode } from "react";
import { useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";

import { Icons } from "../../data/Assets";

import useSignOut from "../../hooks/auth/useSignOut";

import { openModal } from "../../store/slices/modal";

import ProgramsTree from "../sub_components/ProgramsTree";
import OrganizationsTree from "../sub_components/OrganizationsTree";
import { SVGIcon } from "../wrappers/SVGIcon";

import { IOrganizationsTreeProps, IProgramsTreeProps } from "../../interfaces/tree";

interface IMainLayoutProps {
    children: ReactNode;
    programsData?: IProgramsTreeProps;
    organizationsData?: IOrganizationsTreeProps;
};
const MainLayout = (props: IMainLayoutProps) => {
    const { children, programsData, organizationsData } = props;

    const dispatch = useDispatch();

    const { mutate: signOut } = useSignOut();

    const openLogoutModal = () => {
        dispatch(openModal({
            name: 'MESSAGE_MODAL',
            data: {
                view: 'CONFIRMATION',
                closeBtn: false,
                title: "Confirm sign out?",
                content: "Do you want to sign out of your account?",
                actionTxt: "Sign out",
                action: () => signOut(),
            }
        }))
    };

    return (
        <div className="immployer_admin__main_layout">
            <div className="immployer_admin__main_layout__top">
                <h4 className="color_dark">Immployer Admin</h4>
                <button onClick={openLogoutModal}>
                    <SVGIcon src={Icons.LogOff} />
                    <span>Sign out</span>
                </button>
            </div>
            <div className="immployer_admin__main_layout__menu">
                <NavLink
                    to={'/programs'}
                    className={({ isActive }) => `immployer_admin__main_layout__menu__link ${isActive ? 'immployer_admin__main_layout__menu__link__active' : ''}`}
                >
                    Assessment Programs
                </NavLink>
                <NavLink
                    to={'/organizations'}
                    className={({ isActive }) => `immployer_admin__main_layout__menu__link ${isActive ? 'immployer_admin__main_layout__menu__link__active' : ''}`}
                >
                    Organizations
                </NavLink>
            </div>
            <div className="immployer_admin__main_layout__content">
                <div className="immployer_admin__main_layout__content__left">
                    {!!programsData &&
                        <ProgramsTree
                            programs={programsData.programs}
                            selected={programsData.selected}
                            setSelected={programsData.setSelected}
                            expanded={programsData.expanded}
                            setExpanded={programsData.setExpanded}
                        />
                    }
                    {!!organizationsData &&
                        <OrganizationsTree
                            organizations={organizationsData.organizations}
                            selected={organizationsData.selected}
                            setSelected={organizationsData.setSelected}
                            expanded={organizationsData.expanded}
                            setExpanded={organizationsData.setExpanded}
                        />
                    }
                </div>
                <div className="immployer_admin__main_layout__content__right">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default MainLayout;